'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lazyCache = require('./lazyCache');

var _lazyCache2 = _interopRequireDefault(_lazyCache);

exports['default'] = _lazyCache2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-lazy-cache/lib/index.js
// module id = 1006
// module chunks = 0